module.exports = __webpack_public_path__ + "img/front_buttons_quantity.567b807a.png";